import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { TabsContext } from '@mlb/react-patterns/v4/components/Tabs/tabs';
import { TabListOverride, TabsWrapper } from './Tabs.style';

const Tabs = ({
    activeTab,
    items,
    handleTabChange
}) => {
    const onClickHandler = useCallback((event) => {
        handleTabChange(event);
    }, [handleTabChange]);

    const handlers = useMemo(() => {
        return {
            onClick: onClickHandler
        };
    }, [onClickHandler]);

    const list = useMemo(() => items?.map((tab) => {
        return typeof tab === 'string'
            ? {
                name: tab,
                handlers: handleTabChange ? handlers : {}
            }
            : {
                ...tab,
                handlers: handleTabChange ? handlers : {}
            };
    }), [items, handleTabChange, handlers]);

    return (
        <TabsWrapper>
            <TabsContext initialActiveTab={list[activeTab]?.name || activeTab} key={list[activeTab]?.name || activeTab}>
                <TabListOverride list={list} buttonSize={'xl'} />
            </TabsContext>
        </TabsWrapper>

    );
};

Tabs.propTypes = {
    activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    items: PropTypes.array,
    handleTabChange: PropTypes.func
};

export default Tabs;
